import { Component, OnDestroy, OnInit } from '@angular/core';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { tap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { AudienceTrafficService } from 'src/app/services/audience-services/audience-traffic-service/audience-traffic.service';
import { DashboardService } from 'src/app/services/dashboard-services/dashboard.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-audience-social',
  templateUrl: './audience-social.component.html',
  styleUrls: ['./audience-social.component.scss']
})
export class AudienceSocialComponent implements OnInit, OnDestroy {

  centers;
  fixedUrl;
  selectedCenters = [];
  showTraffic = true;

  trafficSubscription: Subscription;
  dashboardServiceSubscription: Subscription;

  colors = [
    '#3bafda',
    '#ed5565',
    '#fcbb42',
    '#37bc9b',
    '#967adc',
    '#d770ad',
    '#ff9d00',
    '#75560d',
    '#ffe4b5',
    '#eeeeee',
    '#6d7182',
  ];

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService,
              private dashboardService: DashboardService,
              private audienceTrafficService: AudienceTrafficService,
              private domSanitizer: DomSanitizer,
              private userStorageService: UserStorageService) {
    this.centers = this.userStorageService.getCenterList();
  }

  ngOnInit() {
    this.selectedCenters = [this.centers[0]];
    this.setBreadcrumb();
    if (this.dashboardServiceSubscription) { this.dashboardServiceSubscription.unsubscribe(); }
    this.dashboardServiceSubscription = this.dashboardService.listenReloadStatistics().pipe(
      tap(o => this.selectedCenters = o['centers']),
      tap(o => this.loadData())
    ).subscribe();
  }

  private loadData() {
    this.getTrafficUrl();
  }

  private getTrafficUrl() {
    if (this.selectedCenters[0] !== null && this.selectedCenters[0] !== undefined ) {
      this.showTraffic = true;
      this.fixedUrl = null;
      const centerInternalId = this.selectedCenters[0].InternalId;
      this.trafficSubscription = this.audienceTrafficService.getTrafficUrl(centerInternalId).pipe(
        tap((url) => {
          this.fixedUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(url);
        })
      ).subscribe();
    } else {
      this.showTraffic = false;
    }
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-th', 'breadcrumb-title.audience social'));
  }

  ngOnDestroy() {
    if (this.dashboardServiceSubscription) { this.dashboardServiceSubscription.unsubscribe(); }
    if (this.trafficSubscription) { this.trafficSubscription.unsubscribe(); }
  }

}
